module.exports = __webpack_public_path__ + "d23b5163599596ee8fed5e6c4fce824d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Material-Design-Icons.eot?-g7cqhn
// module id = 1546
// module chunks = 0